define('views/parts/modal/image-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'cropper', 'utils',
    'services/i18n',
    // views
    'views/parts/modal/modal',
    'views/parts/form/file',
    'views/parts/form/sliderbar',
    'views/parts/modal/gallery',
    // templates
    'text!templates/parts/modal/image-modal.html',

], function(
    // Libs
    _, Backbone, Mustache, cropper, U, i18n,
    // views
    VModal,
    VFile,
    VSliderbar,
    VGallery,
    //templates
    TImageModal
) {

    var VImageModal = VModal.extend({
        template: TImageModal,

        event: {
            rotateleft: ".rotate-left",
            rotateright: ".rotate-right"
        },

        events: {
            "click .rotate-left": "onClickRotateImageLeft",
            "click .rotate-right": "onClickRotateImageRight"
        },

        regions: {
            img: ".new-image",
            imgcontainer: ".img-container",
            file: ".file-input-view",
            zoom: ".zoom-control",
            toolsbuttons: ".edit-tool-button",
            imageGallery: ".image-gallery"
        },

        galleryImages: new Backbone.Collection(),

        modal: function() {
            return {
                title: i18n.t(this.options.title),
                className: "image-modal",
            };
        },

        initialize: function(options) {
            options = this.options = _.extend({
                title: "Upload a picture",
            }, options);

            // This creates the 'onBlob' method on Microsoft browsers
            this.createBlobPolyfill();
            
            var model = new Backbone.Model({});

            options.cropper = _.extend({
                /**
                 * viewMode description
                 * 0 - the crop box is just within the container.
                 * 1 - the crop box should be within the image.
                 * 2 - the image should at least take most of the container.
                 * 3 - the image should take all the container, keeping the ratio,
                 *     and if necessarycropping the minimum to achieve it.
                 */
                viewMode: 0,
                autoCropArea: 1,
                movable: false,
                scalable: false,
                zoomable: true,
                dragMode: 'none',
                checkOrientation: false
            }, options.cropper);

            this.view = {
                file: new VFile({
                    context: this,
                    callback: this.onFileChange,
                    accept: "image/*",
                }),

                sliders: {
                    zoom: new VSliderbar({
                        context: this,
                        labels: ["20%", "400%"],
                        className: 'slider-effort',
                        min: 20,
                        max: 400,
                        step: 1,
                        value: 100,
                        model: model,
                        attribute: 'zoom'
                    })
                }
            };

            var galleryImages = this.options.galleryImages;
            if(galleryImages && galleryImages.length != 0) {
                this.galleryImages.add(galleryImages);
            }

            this.listenTo(model, {
                "change:zoom": this.onZoom
            });

            this.listenTo(galleryImages, 'add', 'onImageAdd');
        },

        createBlobPolyfill: function() {
            if (!HTMLCanvasElement.prototype.toBlob) {
                Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
                    value: function(callback, type, quality) {
                        var canvas = this;
                        setTimeout(function() {

                            var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]),
                                len = binStr.length,
                                arr = new Uint8Array(len);

                            for (var i = 0; i < len; i++) {
                                arr[i] = binStr.charCodeAt(i);
                            }

                            callback(new Blob([arr], { type: type || 'image/png' }));
                        });
                    }
                });
            }
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones()
                .assign(this.view.file, this.zone.$file)
                .assign(this.view.sliders.zoom, this.zone.$zoom, { defer: true })
                .renderModal();

            this.delegateEvents();

            this.galleryImages.forEach(function(image) {
                this.renderGallery(image);
            }, this)

            return this;
        },

        renderGallery: function(photo) {
            var galleryImage = new VGallery({
                imageUrl: photo.get('full')
            });
            this.zone.$imageGallery.append(galleryImage.render().$el);
        },

        show: function(model) {
            this.modelMaster = model;
            this.render();
        },

        initCropper: function() {
            this.zone.$img.cropper(this.options.cropper);
        },

        ////////////
        // events //
        ////////////
        onShown: function() {
            this.initCropper();
        },

        onClickRotateImage: function(direction) {
            var rotateValue = 90;
            if (direction === "left") rotateValue = -90;
            this.zone.$img.cropper('rotate', rotateValue);
        },

        onClickRotateImageLeft: function() {
            this.onClickRotateImage('left');
        },

        onClickRotateImageRight: function() {
            this.onClickRotateImage('right');
        },

        onZoom: function(model, value) {
            var zoomvalue = value * 0.005;
            this.zone.$img.cropper('zoomTo', zoomvalue);
        },

        onFileChange: function(file, view) {
            if (view.isImage()) {
                var $img = this.zone.$img,
                    blobURL = URL.createObjectURL(file);

                this.imageName = file.name;

                $img.one('built.cropper', function() {
                        // Revoke when load complete
                        URL.revokeObjectURL(blobURL);
                    })
                    .cropper('reset')
                    .cropper('replace', blobURL);

                this.zone.$toolsbuttons.show();

                view.reset();
            }
        },

        onConfirm: function(confirmed) {
            var $img = this.zone.$img,
                self = this;

            U.log(this);

            if (confirmed) {
              //console.log("Image-Modal:Start : " + new Date().getTime());
                $img.cropper('getCroppedCanvas').toBlob(function(blob) {
                    blob.filename = self.imageName;
                    self._onClose(confirmed, blob);
                });
            } else {
                this._onClose(confirmed, null);
            }

            $img.cropper('destroy');

            // Option to upload the image right away when clicking on the confirm button
            if(this.options.confirmCallback) {
                this.options.confirmCallback();
            }
        },

        _onClose: function(confirmed, blob) {
            var params = [confirmed, blob, this],
                options = this.options;
            _.callback(options.context, options.callback, params);
            this.trigger.apply(this, ['close'].concat(params));
        },
    });

    return VImageModal;
});

